<template>
  <fragment>
    <div class="table-wrapper head-none">
      <div class="table" style="padding-top: 3.2rem">
        <slot
          :tableData="tableData"
          :handleDelete="handleDelete"
          :copyTemplate="copyTemplate"
          :editor="editor"
        />
      </div>
      <Pagination
        v-if="pagination.recordTotal > 1"
        :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal"
        :totalRecord="pagination.recordTotal"
        @handleNextPage="nextPage"
        @handlePrevPage="prevPage"
        @handleJumpPage="jumpPage"
        @handleChangePageSize="changePageSize"
      />
    </div>
    <div class="mask" v-if="dialogVisible">
      <el-dialog
        :visible.sync="dialogVisible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
        :modal="false"
        width="initial"
        custom-class="dialog vertical"
        :center="true"
      >
        <div class="input-box">
          <span class="name fix-width">模板名称：</span>
          <div class="input">
            <el-input
              v-model="info.templateName"
              placeholder="请输入"
              clearable
            />
          </div>
        </div>
        <fragment v-if="routeName === 'shippingTemplate'">
          <div class="input-box">
            <span class="input-box">
              <span class="name fix-width">默认运费：</span>
              <div class="input" style="width: 5.8rem;">
                <el-input
                  v-model="info.firstItem"
                  clearable
                  type="number"
                  placeholder="请输入"
                />
              </div>
              件内
              <div class="input" style="width: 5.8rem;">
                <el-input
                  type="number"
                  v-model="info.shipping"
                  clearable
                  placeholder="请输入"
                />
              </div>
              元
            </span>
          </div>
          <div class="input-box">
            <span class="input-box">
              <span class="name fix-width">每增加：</span>
              <div class="input" style="width: 5.8rem;">
                <el-input
                  type="number"
                  v-model="info.moreItem"
                  clearable
                  placeholder="请输入"
                />
              </div>
              件
            </span>
            <span class="input-box">
              <span class="name">增加运费：</span>
              <div class="input" style="width: 5.8rem;">
                <el-input
                  type="number"
                  v-model="info.addShipping"
                  clearable
                  placeholder="请输入"
                />
              </div>
              元
            </span>
          </div>
        </fragment>
        <div class="input-box">
          <span class="name fix-width">添加省市：</span>
          <div class="input" style="width: 20rem">
            <el-cascader
              ref="cascader"
              style="width: 100%"
              v-model="addArea"
              :options="options"
              collapse-tags
              :props="{
                multiple: true,
                checkStrictly: false
              }"
              clearable
            >
              <template slot-scope="{ node, data }">
                <span>{{ data.label }}</span>
                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
              </template>
            </el-cascader>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="98" @click="cancelSave">
            取消
          </el-button>
          <el-button class="sub-color" size="98" @click="saveTemplate">
            确 定
          </el-button>
        </div>
      </el-dialog>
    </div>
    <el-button
      size="220"
      class="iconfont icon-xinzeng"
      round
      v-permission:add="$route.meta.permission"
      @click="addTemplate"
    >
      新建模板
    </el-button>
  </fragment>
</template>
<script>
import tableOpearting from 'mixins/tableOpearting/'
import { mapActions } from 'vuex'

export default {
  name: 'TableComponent',
  mixins: [tableOpearting],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routeName: {
      type: String
    },
    dialogVisible: {
      type: Boolean
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    this.keyMap = {
      area_list: {
        name: 'areaList',
        area_list: 'options',
        area_id: 'value',
        area_name: 'label',
        area_parent_id: 'classParentId',
        city_list: 'children',
        area_deep: 'classDeep',
        city_two: 'children',
        city_three: 'children',
        city_four: 'children'
      }
    }
    return {
      options: [],
      addArea: []
    }
  },
  created() {
    this._getProvinceCity()
  },
  methods: {
    ...mapActions(['_getAllDownData']),
    /**
     * 获取省市
     * @private
     */
    _getProvinceCity() {
      this.api.getProvinceCity().then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.options = res.areaList.options
      })
    },
    /**
     * 复制模板
     * @param row
     */
    copyTemplate(row) {
      switch (this.routeName) {
        case 'shippingTemplate':
          this.api
            .copyTransportItem({
              transport_id: row.id
            })
            .then(() => {
              this.$notify({
                type: 'success',
                message: '复制成功啦~！😁'
              })
              this.$emit('updateData', vm => {
                vm._getTransportList({
                  curpage: this.pagination.currentPage
                })
                this._getAllDownData() // 更新下拉
              })
            })
          break
        case 'salesArea':
          this.api
            .copySalesAreaItem({
              sales_area_id: row.id
            })
            .then(() => {
              this.$notify({
                type: 'success',
                message: '复制成功啦~！😁'
              })
              this.$emit('updateData', vm => {
                vm._getSalesAreaList({
                  curpage: this.pagination.currentPage
                })
                this._getAllDownData() // 更新下拉
              })
            })
          break
      }
    },
    /**
     * 父子组件通信
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      const condition = vm.$refs.search._returnSearchCondition()
      switch (this.routeName) {
        case 'shippingTemplate':
          vm._getTransportList({
            curpage: this.pagination.currentPage,
            pageSize: size,
            ...condition
          })
          break
        case 'salesArea':
          vm._getSalesAreaList({
            curpage: this.pagination.currentPage,
            pageSize: size,
            ...condition
          })
          break
      }
    },
    /**
     * 删除模板
     * @param row
     */
    delRows(row) {
      const response = res => {
        if (res.code === '404') {
          this.$notify({
            type: 'warning',
            message: res.message
          })
          return Promise.reject()
        } else {
          this.$notify({
            type: 'success',
            message: '删除成功~！'
          })
          this._getAllDownData() // 更新下拉
        }
      }
      switch (this.routeName) {
        case 'shippingTemplate':
          return this.api
            .delTransportItem({
              transport_id: row.id
            })
            .then(res => {
              return response(res)
            })
        case 'salesArea':
          return this.api
            .delSalesAreaItem({
              sales_area_id: row.id
            })
            .then(res => {
              return response(res)
            })
      }
    },
    /**
     * 保存模板
     */
    saveTemplate() {
      if (this.addArea.length === 0) {
        this.$notify({
          type: 'warning',
          message: '请添加完数据后再进行保存~！😕'
        })
        return
      }
      const {
        id,
        moreItem,
        templateName,
        firstItem,
        shipping,
        addShipping
      } = this.info
      const data = {
        transport_id: id,
        transport_title: templateName,
        first_cost: shipping,
        first_piece: firstItem,
        continuation: moreItem,
        continuation_cost: addShipping,
        city_list: this.addArea,
        sales_title: templateName,
        sales_area_id: id
      }
      const routeName = this.routeName
      this.utils._checkSearchCondition(data)
      const func =
        routeName === 'shippingTemplate' ? 'saveTransport' : 'savaSalesArea'
      this.api[func](data).then(() => {
        this.$notify({
          type: 'success',
          message: '保存成功~！😝'
        })
        this.addArea = []
        this.$emit(
          'updateData',
          vm => {
            const data = {
              curpage: vm.pagination.currentPage || 1
            }
            routeName === 'shippingTemplate' && vm._getTransportList(data)
            routeName === 'salesArea' && vm._getSalesAreaList(data)
            vm.dialogVisible = false
          },
          true
        )
        this._getAllDownData() // 更新下拉
      })
    },
    /**
     * 编辑
     * @param row
     */
    editor(row) {
      this.$emit(
        'updateData',
        vm => {
          vm.dialogVisible = true
          vm.info = this.utils._cloneDeep(row)
          this.addArea = row.cityList
        },
        true
      )
      this._getAllDownData() // 更新下拉
    },
    /**
     * 取消保存
     */
    cancelSave() {
      this.$emit(
        'updateData',
        vm => {
          vm.dialogVisible = false
        },
        true
      )
    },
    /**
     * 新建模板保存
     */
    addTemplate() {
      this.$emit(
        'updateData',
        vm => {
          vm.dialogVisible = true
          vm.info = {}
        },
        true
      )
    }
  }
}
</script>
<style lang="scss">
.head-none {
  .el-table__header-wrapper,
  .el-table__fixed-header-wrapper {
    display: none;
  }

  .top-bg {
    padding-left: 1.3rem;
  }

  .order-details {
    .city {
      width: 29rem;
      margin: 0 auto;
      @include m_ellipsis(3);
    }
  }
}
</style>
